import type { StatusColorName } from "@kontextwerk/web-sdk/core/display/status"
import { internalOrderTypeLabels } from "../order-type-labels"

export const formatOrderTypeTagLabel = (value?: string | null) => {
  const normalized = `${value ?? ""}`.trim()

  if (!normalized) return "Ohne Typ"

  if (normalized.length <= 21) return normalized

  return `${normalized.slice(0, 18).trimEnd()}...`
}

/** Compact tag label of a work order: first order type plus `+N` for further types. */
export const formatWorkOrderTypeTagLabel = (
  source: { order_types?: readonly WorkOrderOrderTypeItem[] | null } | null | undefined,
) => {
  const labels = internalOrderTypeLabels(source)
  const firstLabel = formatOrderTypeTagLabel(labels[0])

  return labels.length > 1 ? `${firstLabel} +${labels.length - 1}` : firstLabel
}

export const resolveOrderTypeColor = (_value?: string | null): StatusColorName => "neutral"
